/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Kind_OtherInputs */



/**
* | output |
* | --- |
* | "Details" |
*
* @param {Chat_Activity_Kind_OtherInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_kind_other = /** @type {((inputs?: Chat_Activity_Kind_OtherInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Kind_OtherInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Details")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détails")
	return /** @type {LocalizedString} */ ("Details")
});